<template>
  <div class="home_container">
    <!-- 背景图（中间区域） -->
    <img v-if="isMobile==0" :src="'https://app.choisiyachts.com'+config.home_cover_image" class="home_img"/>
    <img v-if="isMobile==1" :src="'https://app.choisiyachts.com'+config.home_cover_image_mobile" class="home_img"/>

    <!-- 底部组件（固定在底部） -->
    <bottom class="bottom-component"></bottom>
  </div>
</template>

<script>
import { proCategories, proList,getConfig } from '../../request/api.js'
import bottom from './bottom.vue';

export default {
  name: 'Home',
  components: {
    bottom
  },
  data() {
    return {
      config:null,
      isMobile: 0
    }
  },
  mounted() {
    this.isMobile=localStorage.getItem('isMobile')
    getConfig().then(res => {
      this.config = res.data.data
    })
  }
}
</script>

<style>
.home_container {
  display: flex;
  justify-content: space-between;
  flex-direction: column; /* 垂直排列子元素 */
  width: 100%;
  padding-bottom: 0; /* 移除底部内边距，避免底部组件偏移 */
  height: 100%;
  overflow: hidden;
}

/* 背景图：居中显示（中间区域） */
.home_img {
  flex: 1;
  /* 取消绝对定位，让它在Flex流中 */
  width: 100%; /* 可根据需求调整宽度（例如80%屏幕宽） */
  max-width: 100%; /* 最大宽度限制，避免过大 */
  /* 保留从里到外的出现动画 */
  opacity: 0;
  transform: scale(0);
  height: 700px;
  animation: fadeInFromCenter 1.2s forwards;
}

/* 底部组件：固定在底部 */
.bottom-component {
  width: 100%;
  z-index: 10; /* 确保在背景图上方（如果背景图有覆盖风险） */
}

/* 从里到外出现的动画 */
@keyframes fadeInFromCenter {
  0% {
    opacity: 0;
    transform: scale(0); /* 从中心缩成一点 */
  }
  100% {
    opacity: 1;
    transform: scale(1); /* 放大到正常大小 */
  }
}
</style>